import theme from '@styles/theme';
import { FLUID_SECTION_HORIZONTAL_PADDING_CSS } from '@utils/fluidSectionHorizontalPadding';
type OfferColumns = 2 | 3 | 4 | 6;

/** Przesunięcie `.card-content-wrapper` przy hover (≥768px) — dopasowane do wysokości/paddingów kart. */
const CARD_CONTENT_HOVER_TRANSFORM: Record<OfferColumns, string[]> = {
  2: ['none', 'none', 'translateY(-50px)', 'translateY(-50px)', 'translateY(-64px)', 'translateY(-64px)'],
  3: ['none', 'none', 'translateY(-52px)', 'translateY(-52px)', 'translateY(-54px)', 'translateY(-54px)'],
  4: ['none', 'none', 'translateY(-48px)', 'translateY(-48px)', 'translateY(-60px)', 'translateY(-60px)'],
  6: ['none', 'none', 'translateY(-48px)', 'translateY(-48px)', 'translateY(-60px)', 'translateY(-60px)']
};
const CARD_CONTENT_WRAPPER_BASE_TRANSFORM: Record<OfferColumns, string[]> = {
  2: ['translateY(-50px)', 'translateY(-50px)', 'none', 'none', 'none', 'none'],
  3: ['translateY(-56px)', 'translateY(-56px)', 'none', 'none', 'none', 'none'],
  4: ['translateY(-56px)', 'translateY(-56px)', 'none', 'none', 'none', 'none'],
  6: ['translateY(-54px)', 'translateY(-54px)', 'none', 'none', 'none', 'none']
};
export default {
  section: (backgroundColor: string) => ({
    width: '100%',
    backgroundColor: backgroundColor || theme.rawColors.neutralWhite,
    padding: FLUID_SECTION_HORIZONTAL_PADDING_CSS
  }),
  container: {
    margin: '0 auto'
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  headerTitle: {
    marginBottom: 0,
    padding: 0
  },
  headerArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.rawColors.neutralBlack,
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'translateX(4px)'
    }
  },
  title: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
    lineHeight: '110%',
    color: theme.rawColors.neutralBlack,
    fontSize: [theme.fontSizes.h5,
    // mobile - 16px
    theme.fontSizes.h5,
    // mobilelg - 16px
    theme.fontSizes.h4,
    // tablet - 20px
    theme.fontSizes.h3,
    // tabletlg - 24px
    theme.fontSizes.h2,
    // desktop - 32px
    theme.fontSizes.h2 // widescreen - 32px
    ],
    margin: 0,
    whiteSpace: ['normal', 'normal', 'nowrap', 'nowrap', 'nowrap', 'nowrap']
  },
  grid: {
    display: 'flex',
    // wrap przy szer. do 479px (m.in. 375); od 480px — nowrap
    flexWrap: ['wrap', 'wrap', 'nowrap', 'nowrap', 'nowrap', 'nowrap'],
    // Skala vw: 24px ≡ 1.25vw (px → vw: px × 1.25 / 24)
    rowGap: ['4.27vw',
    //'3.3vw', // 8px
    '4.27vw',
    // 8px
    '1.17vw',
    // 16px
    '1.25vw',
    // 16px
    '1.39vw',
    // 24px
    '1.25vw' // 24px
    ],
    columnGap: ['2.14vw',
    //'1.66vw', // 8px
    '2.14vw',
    // 8px
    '1.17vw',
    // 16px
    '1.25vw',
    // 16px
    '1.39vw',
    // 24px
    '1.25vw' // 24px
    ]
  },
  cardSpacer: {
    width: '100%',
    display: ['block', 'block', 'none', 'none', 'none', 'none']
  },
  cardWrapper: (columns: 2 | 3 | 4 | 6 = 4, _mobileColumns: 1 | 2 = 2) => {
    if (columns === 4) {
      return {
        position: 'relative',
        // do 479px (m.in. 375): dwie kolumny w rzędzie; od 480px — pełna szerokość karty
        width: ['calc(50% - 1.075vw)', 'calc(50% - 1.075vw)', '100%', '100%', '100%', '100%'],
        flex: ['0 0 48.8%', 'unset', 'unset', 'unset', 'unset', 'unset']
      };
    }
    if (columns === 6) {
      return {
        position: 'relative',
        // do 479px (m.in. 375): dwie kolumny w rzędzie; od 480px — pełna szerokość karty
        width: ['calc(50% - 1.075vw)', 'calc(50% - 1.075vw)', 'calc(33.1% - 0.585vw)', '100%', '100%', '100%']
      };
    }
    return {
      width: '100%',
      position: 'relative'
    };
  },
  card: (columns: 2 | 3 | 4 | 6 = 4) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    width: '100%',
    ...(columns === 3 ? {
      aspectRatio: '1 / 1'
    } : columns === 2 ? {
      aspectRatio: ['1 / 1', '1 / 1', 'unset', 'unset', 'unset', 'unset'],
      minHeight: ['auto', 'auto', '46.355vw',
      // 356px
      '29.555vw',
      // 378px
      '29.7917vw',
      // 429px (vw = px × 100 / 1440)
      '29.688vw' // 570px
      ]
    } : columns === 6 ? {
      aspectRatio: ['unset', 'unset', '1 / 1', 'unset', 'unset', 'unset'],
      minHeight: ['79.2vw',
      // 297px
      '74vw',
      // 235px
      'unset',
      // 198px
      '12.7604vw',
      // 245px
      '19.1667vw',
      // 276px (vw = px × 100 / 1440)
      '19.2188vw' // 369px
      ]
    } : {
      minHeight: ['79.2vw',
      // 297px
      '74vw',
      // 235px
      '29.981vw',
      // 307px
      '29.555vw',
      // 378px
      '29.723vw',
      // 428px
      '29.688vw' // 570px
      ]
    }),
    backgroundColor: 'rgba(200, 180, 175, 0.35)',
    position: 'relative',
    overflow: 'hidden',
    textDecoration: 'none',
    padding: columns === 6 ? ['16px',
    // mobile
    '16px',
    // mobilelg
    '16px',
    // tablet
    '14px',
    // tabletlg
    '16px',
    // desktop
    '20px' // widescreen
    ] : columns === 2 ? ['32px',
    // mobile
    '32px',
    // mobilelg
    '32px',
    // tablet - 80 left, 72 bottom
    '40px 26px 35px 40px',
    // tabletlg
    '48px 40px 48px 53px',
    // desktop
    '49px 43px 49px 56px' // widescreen
    ] : ['16px',
    // mobile
    '16px',
    // mobilelg
    '26px 18px 26px 32px',
    // tablet
    '26px 18px 26px 32px',
    // tabletlg
    '26px 18px 26px 32px',
    // desktop
    '34px 26px 34px 40px' // widescreen
    ],
    // On mobile: button always visible, no hover
    '& .card-button': {
      opacity: [1, 1, 0, 0, 0, 0],
      transform: ['translateY(0)', 'translateY(0)', 'translateY(50px)', 'translateY(50px)', 'translateY(50px)', 'translateY(50px)']
    },
    '@media (min-width: 768px)': {
      '&:hover': {
        '& .card-content-wrapper': {
          transform: CARD_CONTENT_HOVER_TRANSFORM[columns]
        },
        '& .card-button': {
          opacity: 1,
          transform: 'translateY(0)'
        },
        '& .card-arrow': {
          opacity: 0
        }
      }
    }
  }),
  cardImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.4s ease'
  },
  newLabel: {
    position: 'absolute',
    top: ['8px', '10px', '12px', '14px', '16px', '18px'],
    right: ['8px', '10px', '12px', '14px', '16px', '18px'],
    backgroundColor: theme.rawColors.neutralWhite,
    color: theme.rawColors.neutralBlack,
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.normal,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontSize: ['7px', '8px', '9px', '9px', '10px', '10px'],
    padding: ['6px 3px', '7px 4px', '8px 4px', '8px 4px', '9px 5px', '10px 5px'],
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
    zIndex: 2,
    lineHeight: 1
  },
  cardContentWrapper: (columns: OfferColumns = 4) => ({
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s ease',
    transform: CARD_CONTENT_WRAPPER_BASE_TRANSFORM[columns],
    marginBottom: ['0px', '0px', '0px', '0px', '0px', '0px'],
    maxWidth: '400px'
  }),
  // Brand logo container
  brandLogo: {
    marginBottom: ['16px', '16px', '16px', '10px', '12px', '24px'],
    maxWidth: '100%',
    maxHeight: ['inherit', 'inherit', '520px', '520px', '520px', '520px'],
    height: ['33px', '33px', 'auto', 'auto', 'auto', 'auto'],
    picture: {
      position: 'relative',
      '& img': {
        position: 'static !important',
        maxWidth: '100% !important',
        width: 'auto !important',
        height: ['100% !important', '100% !important', 'auto !important', 'auto !important', 'auto !important', 'auto !important']
      }
    }
  },
  cardContent: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: ['8px', '10px', '12px', '12px', '16px', '16px']
  },
  cardButton: (columns: 2 | 3 | 4 | 6 = 4) => ({
    position: 'absolute',
    bottom: columns === 2 ? ['32px', '32px', '32px', '36px', '50px', '52px'] // wyżej dla wariantu 2 kolumn
    : ['16px', '18px', '20px', '24px', '28px', '32px'],
    maxHeight: '36px !important',
    minHeight: '36px !important',
    height: '36px !important',
    padding: '6px 24px 6px !important',
    fontSize: '16px !important',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transform: 'translateY(50px)',
    zIndex: 3
  }),
  cardTitle: (columns: 2 | 3 | 4 | 6 = 4) => ({
    width: ['100%', '100%', '100%', 'calc(100% - 26px)', 'calc(100% - 28px)', 'calc(100% - 40px)'],
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    color: theme.rawColors.neutralWhite,
    lineHeight: '96%',
    fontSize: columns === 6 ? ['22px',
    // mobile
    '24px',
    // mobilelg
    '16px',
    // tablet
    '16px',
    // tabletlg
    '18px',
    // desktop
    '24px' // widescreen
    ] : columns === 4 ? ['24px',
    // mobile
    '24px',
    // mobilelg
    '24px',
    // tablet
    '24px',
    // tabletlg
    '32px',
    // desktop
    '40px' // widescreen
    ] : ['24px',
    // mobile
    '24px',
    // mobilelg
    '24px',
    // tablet
    '24px',
    // tabletlg
    '32px',
    // desktop
    '40px' // widescreen
    ],
    textDecoration: 'none',
    transition: 'text-decoration 0.2s ease',
    textShadow: '0px 0px 100px #000'
  }),
  cardArrow: (columns: 2 | 3 | 4 | 6 = 4) => ({
    position: 'absolute',
    bottom: columns === 2 ? ['16px', '18px', '48px', '56px', '64px', '72px'] : columns === 3 ? ['16px', '18px', '20px', '24px', '28px', '32px'] : ['16px', '18px', '20px', '24px', '28px', '34px'],
    right: columns === 2 ? ['16px', '18px', '20px', '24px', '28px', '67px'] : columns === 3 ? ['16px', '18px', '20px', '24px', '28px', '26px'] : ['16px', '18px', '20px', '18px', '18px', '26px'],
    display: ['none', 'none', 'none', 'flex', 'flex', 'flex'],
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: ['18px', '20px', '22px', '24px', '28px', '40px'],
    zIndex: 2,
    opacity: 1,
    transition: 'opacity 0.3s ease',
    svg: {
      fill: theme.rawColors.neutralWhite,
      path: {
        fill: theme.rawColors.neutralWhite + ' !important'
      }
    }
  }),
  // Story variant styles
  storyCartButton: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.documentUp + 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.rawColors.neutralWhite
  },
  storyContent: {
    position: 'absolute',
    bottom: ['24px', '16px', '20px', '20px', '20px', '28px'],
    right: ['32px', '32px', '32px', '32px', '32px', '32px'],
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    textAlign: 'right',
    maxWidth: '70%'
  },
  storyTitle: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    color: theme.rawColors.neutralWhite,
    fontSize: ['24px', '24px', '16px', '16px', '18px', '24px'],
    lineHeight: '96%',
    marginBottom: '4px',
    textShadow: '0px 0px 100px #000'
  },
  storySubtitle: (underline = true) => ({
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    color: theme.rawColors.neutralWhite,
    fontSize: ['14px', '14px', '14px', '14px', '16px', '16px'],
    letterSpacing: '0.05em',
    lineHeight: '140%',
    textDecoration: underline ? 'underline' : 'none',
    textUnderlineOffset: '2px',
    textShadow: '0px 0px 100px #000'
  })
};